import api from './service/api.js'
import services from './service/service.js'
import permissionServices from './service/permissionService.js'

const Plugins = {
    install (Vue) {
        Vue.prototype.$api = api,
        Vue.prototype.$service = services,
        Vue.prototype.$perms = permissionServices
    }
}

export default Plugins